import React, { memo, useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Bookmark from '../../assets/img/bookmark.png';
import ActiveBookmark from '../../assets/img/bookmarkActive.png';
import { useAddBookToFavoriteMutation, useDeleteBookFromFavoriteMutation } from '../../api/LibraryApi/LibraryService';
import { setIsError } from '../../store/reducers/notificationSlice';
import { useTranslation } from 'react-i18next';
import useDeviceType from '@hooks/useDeviceType';

function BookItem({ book }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [isActive, setIsActive] = useState(book.is_favorite);

    const isAuth = useSelector(state => state.auth.isAuth);
    const user = useSelector(state => state.user);

    const [addBook] = useAddBookToFavoriteMutation();
    const [deleteBook] = useDeleteBookFromFavoriteMutation();

    const isAddFavoriteAvailable = ['teacher', 'student', 'private_user'].includes(user.activeRole);

    const handleBookmarkClick = async (e) => {
        e.stopPropagation();
        if (isActive) {
            const deleteResult = await deleteBook({ book_id: book.book_id });
            if (deleteResult.error) {
                //TODO (не все коды есть в спецификации)
                dispatch(setIsError(t(`general.models.serverErrors.deleteBook.${deleteResult.error.data.error_code}`)));
            } else {
                setIsActive(false);
            }
        } else {
            const addResult = await addBook({ book_id: book.book_id });
            if (addResult.error) {
                dispatch(setIsError(t(`general.models.serverErrors.addBook.${addResult.error.data.error_code}`)));
            } else {
                setIsActive(true);
            }
        }
    };

    const isNew = (book.is_new && book.is_published)
    const saveBook = () => {
        localStorage.setItem("bookData", JSON.stringify({
            url: `${import.meta.env.VITE_OQULYQTAR_API_URL}/library/get-book-v2/${book.book_id}`,
            book_url: book.url,
            id: book.book_id
        }));
    }
    const {isMobile, isDesktop, isTablet} = useDeviceType();
    return (
      <div>
          {
              isMobile && (
              <div className='relative w-[156px] m-2 desktop:m-4 flex flex-col hover:cursor-pointer'>
                  <Link
                    to={isNew ? `/library/new/${book.book_id}` : `/library/${book.book_id}`}
                    onClick={()=>{
                        saveBook()
                    }}
                  >
                      <div className='h-[208px]'>
                          <img className={'h-full'} src={book.cover_mediafile || book.cover} alt={book.name}/>
                      </div>
                      <span className='text-gray-400 mt-2'>"{book.publisher}"</span>
                      <span className='line-clamp-3'>{book.name}</span>
                  </Link>
                  {isAuth && isAddFavoriteAvailable && <img
                    className={'absolute top-[-2px] cursor-pointer z-10 right-1'}
                    src={isActive ? ActiveBookmark : Bookmark}
                    alt={'Bookmark'}
                    onMouseDown={handleBookmarkClick}
                  />}
              </div>
            )
          }

          {
              isTablet && (
              <div className='relative w-[184px] m-2 tablet:flex flex-col hover:cursor-pointer'>
                  <Link
                    to={isNew ? `/library/new/${book.book_id}` : `/library/${book.book_id}`}
                    onClick={()=>{
                        saveBook()
                    }}
                  >
                      <div className='h-[245px]'>
                          <img className={'h-full'} src={book.cover_mediafile || book.cover} alt={book.name}/>
                      </div>
                      <span className='text-gray-400 mt-2'>"{book.publisher}"</span>
                      <span className='line-clamp-3'>{book.name}</span>
                  </Link>
                  {isAuth && isAddFavoriteAvailable && <img
                    className={'absolute top-[-2px] cursor-pointer z-10 right-1'}
                    src={isActive ? ActiveBookmark : Bookmark}
                    alt={'Bookmark'}
                    onMouseDown={handleBookmarkClick}
                  />}
              </div>
            )
          }
          {
              isDesktop && (
              <div className='relative w-[115px] m-1 desktop:m-4 flex-col hover:cursor-pointer desktop:flex'>
                  <Link
                    to={isNew ? `/library/new/${book.book_id}` : `/library/${book.book_id}`}
                    onClick={()=>{
                        saveBook()
                    }}
                  >
                      <div className='h-[153px]'>
                          <img className={'h-full'} src={book.cover_mediafile || book.cover} alt={book.name}/>
                      </div>
                      <span className='text-gray-400 mt-2'>"{book.publisher}"</span>
                      <span className='line-clamp-3'>{book.name}</span>
                  </Link>
                  {isAuth && isAddFavoriteAvailable && <img
                    className={'absolute top-[-2px] cursor-pointer z-10 right-1'}
                    src={isActive ? ActiveBookmark : Bookmark}
                    alt={'Bookmark'}
                    onMouseDown={handleBookmarkClick}
                  />}
              </div>
            )
          }
      </div>
    );
}

export default memo(BookItem);
